import { inject } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';

import { firstValueFrom } from 'rxjs';
import { map } from 'rxjs/operators';

import { CashierConfig } from '../cashier.client-config';
import { QuickDepositService } from './quick-deposit.service';

export const quickDepositGuard = async (route: ActivatedRouteSnapshot) => {
    const quickDepositService = inject(QuickDepositService);
    const config = inject(CashierConfig);

    if (route.params['action'] !== 'deposit') {
        return true;
    }

    await firstValueFrom(config.whenReady);

    return firstValueFrom(
        quickDepositService.isEnabled().pipe(
            map((enabled: boolean) => {
                if (enabled) {
                    quickDepositService.open({ showKYCVerifiedMessage: false });
                    return false;
                }
                return true;
            }),
        ),
    );
};
